import { APIClient } from "../../../helpers/api_helper";

const api = new APIClient();

  export const createCatalog = async (data) => {
      try {
        const response = await api.create(`/instructions/add`, data);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const getCatalogs = async () => {
      try {
        const response = await api.get(`/instructions/all`);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const updateCatalog = async ( id, data) => {
      try {
        const response = await api.put(`/instructions/update/${id}`, data);
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const deleteCatalog = async (id) => {
    try {
        const response = await api.delete(`/instructions/delete/${id}`);
        return response;
    } catch (error) {
        throw error;
    }
  };

  export const getCatalogsByCategory = async (category) => {
    try {
        const response = await api.get(`/instructions/category/${category}`);
        return response;
    } catch (error) {
        throw error;
    }
  };

  export const getCatalogsByType = async (type) => {
    try {
        const response = await api.get(`/instructions/type/${type}`);
        return response;
    } catch (error) {
        throw error;
    }
  };
